import { ICompanySchema } from '@company/types/company';
import { Editor } from '@tiptap/react';
import { initialFormik } from '@utils/common';
import { FormikProps } from 'formik';
import { createContext } from 'react';

const CompanySetupContext = createContext<{
    formik: FormikProps<Partial<ICompanySchema>>;
    editor: Editor | null;
}>({
    formik: initialFormik,
    editor: null,
});

export { CompanySetupContext };
